module.exports = __webpack_public_path__ + "assets/BngMUXZYTXPIvIBgJJSb6ufO5qW54A-d394b3.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/BngMUXZYTXPIvIBgJJSb6ufO5qW54A.woff2
// module id = 870
// module chunks = 2